import React from 'react';
import {
  KeywordPreviewFilter,
  UrlPreviewFilter,
} from './KeywordUrlPreviewFilter';
import { KeywordFilter, UrlFilter } from './KeywordUrlFilter';
import { TKeywordUrlPreviewFilterProps } from '../../types';

export default function Filter({
  isPreview,
  promptInfoMap,
  tab,
  ...props
}: TKeywordUrlPreviewFilterProps & { isPreview: boolean }) {
  const isKeyword = tab === 'keyword';

  if (isPreview) {
    const Component = isKeyword ? KeywordPreviewFilter : UrlPreviewFilter;
    return (
      <Component tab={tab} promptInfoMap={promptInfoMap} {...props}></Component>
    );
  }

  const FilterComponent = isKeyword ? KeywordFilter : UrlFilter;
  return <FilterComponent tab={tab} {...props}></FilterComponent>;
}
